<template>
  <div class="user user__menu">
    <div class="photo">
      <img :src="user.photoURL ?? 'img/default-avatar.png'" alt="avatar" />
    </div>
    <div class="info" v-if="user.displayName === 'Login'">
      <a
        data-toggle="collapse"
        href="#userMenu"
        role="button"
        aria-controls="userMenu"
        aria-expanded="false"
        @click="goToLogin"
      >
        <span>
          {{ user.displayName }}
        </span>
      </a>
    </div>
    <div class="info" v-if="user.displayName !== 'Login'">
      <a
        data-toggle="collapse"
        href="#userMenu"
        role="button"
        aria-controls="userMenu"
        aria-expanded="false"
      >
        <span>
          {{ user.displayName }}
          <b class="caret"></b>
        </span>
      </a>
      <div class="collapse" id="userMenu">
        <ul class="nav user-menu__nav">
          <slot>
            <li>
              <router-link :to="'/user/' + user.uid">
                <span class="sidebar-mini-icon">MP</span>
                <span class="sidebar-normal">ข้อมูลผู้ใช้</span>
              </router-link>
            </li>
            <li>
              <a href="#vue" @click="logOut">
                <span class="sidebar-mini-icon">L</span>
                <span class="sidebar-normal">ออกจากระบบ</span>
              </a>
            </li>
          </slot>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
export default {
  methods: {
    getProfile() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.user = user;
        }
      });
    },
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            localStorage.clear();
            window.location = "/game";
          },
          (error) => {
            // An error happened.
          }
        );
    },
    goToLogin() {
      this.$router.push("/login");
    },
  },
  data() {
    return {
      user: {
        uid: "",
        displayName: "Login",
        photoURL: "/img/default-avatar.png",
      },
    };
  },
  name: "user-menu",
  created() {
    let currentUser = firebase.auth().currentUser;
    let uid = "";
    if (currentUser) {
      uid = currentUser.uid;
    } else {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          uid = user.uid;
          if (user.uid) {
            this.getProfile();
          }
        }
      });
    }
    if (uid !== "") {
      this.getProfile();
    }
  },
};
</script>
<style>
.user__menu ul.user-menu__nav {
  margin-top: 0;
  padding-top: 20px;
}
</style>
